import styled, { css } from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
`;

export default Wrapper;

export const Menu = styled.div`
  padding: ${(props) => {
    return props.menuPadding ? props.menuPadding : '12px 24px 8px 24px';
  }};
  color: ${color.black1};
  font-size: 16px;
  font-weight: 600;
  display: inline-block;
  margin-right: 10px;
  cursor: pointer;
  border-radius: ${(props) => {
    return props.menuBorderRadius ? `${props.menuBorderRadius}px` : '100px';
  }};
  border: 1px solid transparent;
  min-width: ${(props) => {
    return props.menuMinWidth ? `${props.menuMinWidth}px` : 'unset';
  }};
  ${(props) => {
    return (
      props.menuColor === 'green' &&
      css`
        font-size: 14px;
        color: ${color.black2};
      `
    );
  }}
  :hover {
    background-color: transparent;
    border: 1px solid ${color.grey1};
    ${(props) => {
      return (
        props.menuColor === 'green' &&
        css`
          border: 1px solid ${color.green6};
        `
      );
    }}
  }

  &.active {
    background-color: ${color.grey1};
    border: 1px solid ${color.grey1};
    ${(props) => {
      return (
        props.menuColor === 'green' &&
        css`
          background-color: ${color.green6};
          border: 1px solid ${color.green6};
          color: ${color.black1};
        `
      );
    }}
  }
`;
